import React, { useEffect, useRef, useState } from "react";
import { ChevronDown, Check } from "lucide-react";

// options: array of strings OR [{value,label}]. selected: array of values.
export function MultiSelect({ label, options = [], selected = [], onChange, testid = "multiselect", placeholder = "All" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const opts = options.map((o) => (typeof o === "string" ? { value: o, label: o } : o));

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const toggle = (v) => {
    const next = selected.includes(v) ? selected.filter((x) => x !== v) : [...selected, v];
    onChange(next);
  };

  const summary = selected.length === 0 ? placeholder
    : selected.length === 1 ? (opts.find((o) => o.value === selected[0])?.label || selected[0])
    : `${selected.length} selected`;

  return (
    <div className="relative" ref={ref}>
      {label && <div className="text-[11px] text-muted-foreground mb-0.5">{label}</div>}
      <button type="button" data-testid={`${testid}-trigger`} onClick={() => setOpen((o) => !o)}
        className="h-10 min-w-[150px] px-3 rounded-md border border-input bg-card text-sm flex items-center justify-between gap-2 hover:bg-muted transition-colors">
        <span className={`truncate ${selected.length === 0 ? "text-muted-foreground" : ""}`}>{summary}</span>
        <ChevronDown size={15} className="shrink-0 text-muted-foreground" />
      </button>
      {open && (
        <div data-testid={`${testid}-menu`} className="absolute z-50 mt-1 w-full min-w-[180px] max-h-64 overflow-y-auto rounded-md border border-border bg-card shadow-lg p-1">
          {opts.length === 0 ? (
            <div className="px-3 py-2 text-xs text-muted-foreground">No options</div>
          ) : (
            <>
              {selected.length > 0 && (
                <button type="button" data-testid={`${testid}-clear`} onClick={() => onChange([])}
                  className="w-full text-left px-3 py-1.5 text-xs text-muted-foreground hover:bg-muted rounded">Clear all</button>
              )}
              {opts.map((o) => {
                const on = selected.includes(o.value);
                return (
                  <button key={o.value} type="button" data-testid={`${testid}-opt-${o.value}`} onClick={() => toggle(o.value)}
                    className="w-full text-left px-3 py-1.5 text-sm flex items-center gap-2 hover:bg-muted rounded transition-colors">
                    <span className={`h-4 w-4 shrink-0 rounded border flex items-center justify-center ${on ? "bg-primary border-primary text-primary-foreground" : "border-input"}`}>
                      {on && <Check size={12} />}
                    </span>
                    <span className="truncate">{o.label}</span>
                  </button>
                );
              })}
            </>
          )}
        </div>
      )}
    </div>
  );
}
